// src/components/Navbar.js
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Navbar.css';

const Navbar = ({ onLogout }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const navigationItems = [
    { path: '/', label: '🏠 Sensors', end: true },
    { path: '/lights', label: '💡 Lights', end: true },
    { path: '/fh', label: '🔥 Heating', end: true },
    { path: '/cast', label: '📱 Cast', end: true },
    { path: '/audio', label: '🎵 Audio', end: false },
    { path: '/archive', label: '📁 Archive', end: false },
    { path: '/location', label: '📍 SoundMon', end: false },
    { path: '/esp32', label: '🔌 ESP32', end: false },
    { path: '/radar', label: '📡 Radar', end: false },
    { path: '/upload', label: '📹 Upload', end: false },
    { path: '/cogni', label: '🧠 Cogni', end: false },
    { path: '/lumen', label: '🏄 Lumen', end: false },
    { path: '/chat', label: '💬 Chat', end: false },    
    { path: '/cv', label: '📄 CV', end: false },
    { path: '/test', label: '🧪 Test', end: false },
  ];

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <span className="brand-text">🏡 Home Dashboard</span>
      </div>

      {/* Hamburger Menu Button */}
      <button 
        className={`hamburger ${isMenuOpen ? 'active' : ''}`}
        onClick={toggleMenu}
        aria-label="Toggle navigation menu"
      >
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
      </button>

      {/* Navigation Menu */}
      <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
        <ul className="nav-list">
          {navigationItems.map((item) => (
            <li key={item.path} className="nav-item">
              <NavLink 
                to={item.path} 
                end={item.end}
                className="nav-link"
                onClick={closeMenu}
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
        
        <div className="nav-footer">
          <button className="logout-button" onClick={() => { onLogout(); closeMenu(); }}>
            🚪 Logout
          </button>
        </div>
      </div>

      {/* Overlay for mobile menu */}
      {isMenuOpen && <div className="nav-overlay" onClick={closeMenu}></div>}
    </nav>
  );
};

export default Navbar;
